import { Guid } from "guid-typescript"
import { FilteredDropDownModel, ListModel } from "shared/interfaces/core-interfaces"
import * as yup from 'yup';

export interface NotesSliceModel {
    note?: Note,
    noteModel: NoteModel,
    notesByContact: Note[],
    notesByCompany: Note[],
    notesByEmployee: Note[],

    statusCode: string,
    message: string,
    showNotification: boolean,
    reloadData: boolean,

    isLoading: boolean,

    filteredPartnersList: FilteredDropDownModel,
    filteredContactsList: FilteredDropDownModel,
}

export interface DocumentDTO {
    id: Guid,
    fileName: string,
    description: string,
    fileBase64: string,
    createdBy: string,
    createdAt: Date,
}

export interface Note {
    id: string,
    contacts: ListModel<string>[] | [],
    companies: ListModel<string>[] | [],
    createdById: string,
    createdBy: string,
    createdAt: Date,
    content: string,
    files: Attachment[]
}

export interface Attachment {
    id: string,
    fileName: string,
    description: string,
    fileBase64: string,
    createdAt: Date,
    //isImage: boolean,
    filePrefix: string
}

export interface FileWithId {
    id: string,
    file: File
}

export interface CreateNoteRequest {
    associatedCompanies: string[] | null,
    associatedContacts: string[] | null,
    content: string,
    files: Attachment[] | [],
}

export interface UpdateNoteRequest extends CreateNoteRequest {
    id: string
}

export interface UploadNoteFilesRequest {
    noteId: string,
    files: Attachment[] | [],
}

export interface NoteFilesResponse {
    id: Guid,
    message: string
    files: Attachment[]
}

// --------------------------------

const nonWhitespaceRegExp = /^(?!<p>\s*<\/p>$).+/;

export const CreateNoteRequestSchema = yup.object().shape({
    associatedCompanies: yup.array().of(yup.string().defined()).nullable().default([]),
    associatedContacts: yup.array().of(yup.string().defined()).nullable().default([]),
    content: yup.string()
        .required("Note text is required.")
        .notOneOf(["<p><br></p>"], "Note text cannot be empty.")
        .matches(nonWhitespaceRegExp, "Note text cannot be empty or whitespace.")
        .default(""),
    files: yup.array().of(yup.object({
        id: yup.string().defined(),
        fileName: yup.string().required("File name is required.").default(""),
        description: yup.string().default(""),
        fileBase64: yup.string().required("File content is required.").default(""),
        createdAt: yup.date().required("File creation date is required.").default(new Date()),
        filePrefix: yup.string().required("Prefix string is required.").default(""),
        //isImage: yup.boolean().required("Is image flag is required.").default(false),
    })).default([]),
});

export const UpdateNoteRequestSchema = CreateNoteRequestSchema.concat(
    yup.object().shape({
        id: yup.string().required().defined(),
    })
);


export interface NoteModel {
    id: string | null,
    associatedCompanies: ListModel<string>[] | [],
    associatedContacts: ListModel<string>[] | [],
    content: string,
    files: Attachment[] | [],
}

export const initialNoteValue: NoteModel = {
    id: null,
    associatedCompanies: [],
    associatedContacts: [],
    content: "",
    files: [],
}

export const NoteModelScheme = yup.object().shape({
    id: yup.string().defined().nullable(),
    associatedCompanies: yup.array().defined(),
    associatedContacts: yup.array().defined(),
    content: yup.string()
        .required("Note text is required.")
        .notOneOf(["<p><br></p>"], "Note text cannot be empty.")
        .matches(nonWhitespaceRegExp, "Note text cannot be empty or whitespace.")
        .default(""),
    files: yup.array().of(yup.object({
        id: yup.string().defined(),
        fileName: yup.string().required("File name is required.").default(""),
        description: yup.string().default(""),
        fileBase64: yup.string().required("File content is required.").default(""),
        createdAt: yup.date().required("File creation date is required.").default(new Date()),
        filePrefix: yup.string().required("Prefix string is required.").default(""),
    })).default([]),
})